import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useMessageDrawerStore = defineStore('messageDrawer', () => {
  const visible = ref(false)

  /** 打开消息抽屉，可供任意地方调用 */
  const open = () => {
    visible.value = true
  }

  /** 关闭消息抽屉，可供任意地方调用 */
  const close = () => {
    visible.value = false
  }

  /** 切换消息抽屉显示/隐藏 */
  const toggle = () => {
    visible.value = !visible.value
  }

  const reset = () => {
    visible.value = false
  }

  return {
    visible,
    open,
    close,
    toggle,
    reset,
  }
})
